// Funding section configuration
// Defines fields for previous funding and capital needs
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for funding section
export const fundingSectionSchema = z.object({
  hasReceivedInvestment: z.string().min(1, 'Este campo es requerido'),
  investmentSource: z.string().min(1, 'Este campo es requerido'),
  investmentAmount: z.string().min(1, 'Este campo es requerido'),
  seekingCapital: z.string().min(1, 'Este campo es requerido'),
  resourceUsage: z.string().min(1, 'Este campo es requerido'),
});

export type FundingSectionData = z.infer<typeof fundingSectionSchema>;

// Section config
export const fundingSection: SectionConfig = {
  id: 'funding',
  titleKey: 'Financiamiento previo y necesidades',
  descriptionKey: 'Información sobre inversiones recibidas y necesidades de capital',
  validationSchema: fundingSectionSchema,
  fields: [
    {
      name: 'hasReceivedInvestment',
      type: 'radio',
      label: '¿Has recibido inversión previamente?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
      ],
    },
    {
      name: 'investmentSource',
      type: 'text',
      label: '¿De parte de quién has recibido financiamiento?',
      placeholder: 'Indica la fuente del financiamiento...',
      required: true,
    },
    {
      name: 'investmentAmount',
      type: 'text',
      label: '¿De parte cuánto fue el financiamiento?',
      placeholder: 'Indica el monto recibido...',
      required: true,
    },
    {
      name: 'seekingCapital',
      type: 'radio',
      label: '¿Buscas levantar capital en el corto plazo?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
      ],
    },
    {
      name: 'resourceUsage',
      type: 'textarea',
      label: '¿Para qué usarías recursos o apoyo?',
      placeholder: 'Describe cómo utilizarías los recursos...',
      required: true,
    },
  ],
};
